<div class="container-fluid py-3">

  <!-- Header -->
  <div class="row mb-3 align-items-center">
    <div class="col d-flex align-items-center gap-2">
      <button
        type="button"
        (click)="goBack()"
        aria-label="Volver a casas"
        title="Volver"
        class="btn btn-sm btn-light rounded-circle flex-shrink-0">
        <i class="material-icons mt-1">arrow_back</i>
      </button>
      <div>
        <h6 class="mb-0 fw-bold">Amonestaciones</h6>
        <small class="text-secondary">{{ houseLabel }}</small>
      </div>
    </div>
    <div class="col-auto">
      <button
        type="button"
        (click)="create()"
        [disabled]="moduleDisabled"
        aria-label="Nueva amonestación"
        title="Nueva amonestación"
        class="btn btn-success rounded-circle">
        <i class="material-icons mt-1">add</i>
      </button>
    </div>
  </div>

  @if (moduleDisabled) {
    <div class="alert alert-warning d-flex align-items-center gap-2" role="alert">
      <i class="material-icons">info</i>
      <div>
        El módulo de amonestaciones no está habilitado en este fraccionamiento.
        No se pueden registrar nuevas amonestaciones hasta que se habilite.
      </div>
    </div>
  }

  @if (loading) {

    <div class="text-center py-4">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Cargando...</span>
      </div>
    </div>

  } @else if (noticeViolations.length === 0) {

    <div class="bg-white rounded-3 shadow-sm p-4 text-center text-secondary">
      Esta casa no tiene amonestaciones.
    </div>

  } @else {

    <div class="row">
      @for (noticeViolation of noticeViolations; track noticeViolation.noticeViolationId) {
        <div class="col-12 col-xl-6 mb-3">
          <div class="bg-white rounded-3 shadow-sm p-3 h-100 d-flex flex-column gap-2">

            <div class="d-flex align-items-start gap-2">
              <div class="flex-grow-1 notice-title">
                <div class="fw-bold">{{ noticeViolation.title }}</div>
                <small class="text-secondary">
                  {{ noticeViolation.createdAt | dateToMoment: 'DD MMM YYYY HH:mm' : neighborhoodService.currentNeighborhood?.timeZone }}
                </small>
              </div>
              <span
                class="badge rounded-pill flex-shrink-0"
                [ngClass]="noticeViolation.status ? 'text-bg-success' : 'text-bg-secondary'">
                {{ noticeViolation.status ? 'Activa' : 'Inactiva' }}
              </span>
            </div>

            <div class="notice-description text-secondary">
              {{ noticeViolation.description }}
            </div>

            <div class="d-flex align-items-center gap-2 mt-auto">
              <span class="d-inline-flex align-items-center gap-1 text-secondary me-auto">
                <i class="material-icons" style="font-size: 1.1rem;">attach_file</i>
                {{ noticeViolation.files.length }}
              </span>
              <button
                (click)="view(noticeViolation)"
                aria-label="Ver amonestación"
                title="Ver"
                class="btn btn-sm btn-light rounded-circle">
                <i class="material-icons mt-1">visibility</i>
              </button>
              <button
                (click)="view(noticeViolation, true)"
                aria-label="Editar amonestación"
                title="Editar"
                class="btn btn-sm btn-light rounded-circle">
                <i class="material-icons mt-1">edit</i>
              </button>
              <button
                (click)="delete(noticeViolation)"
                aria-label="Eliminar amonestación"
                title="Eliminar"
                class="btn btn-sm btn-danger rounded-circle">
                <i class="material-icons mt-1">delete</i>
              </button>
            </div>

          </div>
        </div>
      }
    </div>

  }

</div>
